










import {
  defineComponent,
} from '@vue/composition-api';

import CommonFormWithDeliveryEditor from '@/components/Delivery/CommonFormWithDeliveryEditor.vue';

const EditDelivery = defineComponent({
  components: {
    CommonFormWithDeliveryEditor,
  },
});

export default EditDelivery;
